module.exports = __webpack_public_path__ + "img/bookmark-agenda.aa640144.svg";